import axios from "axios";
import { Base_URL } from "../url";

export const fetchProVenMappings = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ProVenMapping/GetAllProVenMappings`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching project-vendor mappings!";
  }
};

export const downloadProVenMappingsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ProVenMapping/DownloadProVenMappingsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading project-vendor mappings data!";
  }
};